export const stringToVariant = (() => {
  const variants = {
    primary: [],
    secondary: [],
    success: [],
    danger: [],
    warning: [],
    info: [],
    light: [],
    dark: [],
  };
  const result = {};
  return (str) => {
    if (result[str]) return result[str];

    const [variant, ] = Object.keys(variants).sort(
      (a, b) => variants[a].length - variants[b].length
    );
    variants[variant].push(str);
    result[str] = variant;
    return result[str];
  };
})();
